export enum SEARCH_PARAMS {
    DAYS = 'days',
    COIN = 'coin',
    CURRENCY = 'currency',
    PAGE = 'page'
 }; 